import { motion } from 'framer-motion';

function PayOnline() {
  return (
    <div className="container mx-auto px-4 py-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center"
      >
        <h1 className="text-3xl md:text-4xl font-bold text-dark-blue">Pay Online</h1>
        <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
          Make secure payments for our services quickly and easily.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="mt-12 max-w-lg mx-auto"
      >
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="mb-4">
            <label className="block text-gray-700">Card Number</label>
            <input type="text" className="w-full p-2 border rounded" />
          </div>
          <div className="mb-4 flex gap-4">
            <div className="flex-1">
              <label className="block text-gray-700">Expiry Date</label>
              <input type="text" className="w-full p-2 border rounded" placeholder="MM/YY" />
            </div>
            <div className="flex-1">
              <label className="block text-gray-700">CVC</label>
              <input type="text" className="w-full p-2 border rounded" />
            </div>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Amount</label>
            <input type="text" className="w-full p-2 border rounded" />
          </div>
          <button className="w-full bg-sky-blue text-white py-2 rounded hover:bg-dark-blue transition">
            Pay Now
          </button>
        </div>
      </motion.div>
    </div>
  );
}

export default PayOnline;